// What a field's description is, in one place for FieldShell and Select (DZ-10801): the error when there is one,
// else the hint. aria-describedby names exactly what renders, never an id that isn't on the page.

export interface FieldDescription { kind: 'error' | 'hint'; id: string }

export function fieldDescription(id: string, hint: unknown, error: unknown): FieldDescription | null {
  if (error) return { kind: 'error', id: `${id}-error` };
  if (hint) return { kind: 'hint', id: `${id}-hint` };
  return null;
}

/** A hidden-label control still needs its shell when it has something to say: a hint or an error. */
export function needsShell(labelHidden: boolean | undefined, hint: unknown, error: unknown): boolean {
  return !labelHidden || fieldDescription('', hint, error) !== null;
}
